import { useUIStore } from 'Modules/ui/index.store';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { routeChecks } from 'Utils/routeUtils';

const useHistoryDetailsPanel = () => {
  const location = useLocation();
  const { showChatHistory, setIsChatHistoryOpen } = useUIStore();

  useEffect(() => {
    if (showChatHistory && !routeChecks.isVideoHistoryDetailsPage()) {
      setIsChatHistoryOpen(false);
    }
  }, [showChatHistory, setIsChatHistoryOpen, location.pathname]);

  return {
    isOpen: showChatHistory,
  };
};

export default useHistoryDetailsPanel;
